import { Pipe, PipeTransform } from '@angular/core';
import { ViewModel, DateUtil } from '@farris/devkit';
@Pipe({ name: 'dateFormatPlaceholder' })
export class DateFormatPlaceholderPipe implements PipeTransform {
    constructor(private viewModel: ViewModel) {

    }
    transform(format: string, controlName: string): any {
        if (!this.viewModel.form || !this.viewModel.form.get(controlName)) {
            return {
                year: 'å¹´',
                month: 'æ',
                day: 'æ¥'
            };
        }
        const value = this.viewModel.form.get(controlName).value;
        let dateStr = value;
        if (dateStr) {
            dateStr = value.toISOString();
        }
        if ((DateUtil.isEmptyDateString(dateStr) === true) && format === 'yyyyå¹´MMæddæ¥') {
            return {
                year: ' ',
                month: ' ',
                day: ' '
            };
        }
        return {
            year: 'å¹´',
            month: 'æ',
            day: 'æ¥'
        };
    }
}
